import React from "react";
import styles from './cardProdutoDestaque.module.css';
import { FaRocket } from "react-icons/fa";
import { Link } from "react-router-dom";

function CardProdutoDestaque({ src, label_title, p_preco, id_item, p_descricao }) {
  return (
    <Link to={`/pedidoclique/${id_item}`} state={{ id_item, src, label_title, p_preco, p_descricao }}>
      <div className={styles.cardDestaque} key={id_item}>
        <img
          src={src}
          alt={label_title}
          className={styles.imgDestaque}
        />
        <div className={styles.infoDestaque}>
          <span className={styles.nomeItem}>{label_title}</span>
      
          <span className={styles.precoItem}>R$ {p_preco}</span>
          <div className={styles.tagDestaque}>
            <FaRocket className={styles.iconeRocket} /> Destaque
          </div>
        </div>
      </div>
    </Link> 
  );
}

export default CardProdutoDestaque;
